import { Button, Grid, Typography, useTheme } from '@mui/material'
import { AccountBalanceWalletOutlined } from '@mui/icons-material';
import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../Redux/store';
import { KaziLayout } from '../../../Shared Components/Kazi/Layouts/KaziLayout';
import { AddPaymentMethod } from '../../../Shared Components/AddPaymentMethod';
import { useLazyCreateSetupIntentQuery } from '../../../Redux/api/stripeApi';
import { useUser } from '../../../Hooks/useUser';
import { useToast } from '../../../Hooks/useToast';
import { setClientSecret, setCustomerSessionClientSecret } from '../../../Redux/slices/GlobalSlice';
import { setShowAddPaymentMethodModal } from '../../../Redux/slices/GlobalModalSlice';

export const ConnectWallet = () => {
    /* ******************** Hooks ******************** */
    const theme = useTheme();
    const { locator } = useUser();
    const { showToast } = useToast();
    const dispatch = useAppDispatch();
    const userType = useAppSelector( state => state.Global.userType);
    const [ 
        createSetupIntent
    ] = useLazyCreateSetupIntentQuery();
    /* ******************** Variables ******************** */
    const isClient = userType === 'client'
    /* ******************** Functions ******************** */
    const handleConnect = () => {
        if (isClient) {
            createSetupIntent(locator!)
            .unwrap()
            .then( res => {
                dispatch(setClientSecret(res.clientSecret));
                dispatch(setCustomerSessionClientSecret(res.clientSecret));
                dispatch(setShowAddPaymentMethodModal(true))
            })
            .catch( err => {
                console.error("Error occured while creating setup intent: ", err);
                showToast({
                    text: "Unable to connect payment",
                    variant: "error"
                })
            })
        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={"100%"}
                height={"100%"}
                marginTop={8}
                gap={'30px'}
            >
                <AccountBalanceWalletOutlined sx={{ width:"100px", height:"100px", color: theme.palette.green[200]}}/>
                <Typography>
                    Connect your bank account to {isClient ? 'make payments to Talents' :'receive payments from Clients'} for short-term projects.
                </Typography>
                <Button variant='contained' size='large' onClick={handleConnect}>Connect</Button>
            </Grid>
        </>
    )
}
